import { useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import DateTimePickerField from 'components/forms/dateTimePickerField/DateTimePickerField';
import { PreArrivalFormFields } from '../../PreArrivalFormTab.types';
import useShouldShowField from '../useShouldShowField';
import {
  ArrivalInfoContainer,
  PreviewDivider,
  PreviewRow,
} from '../PreviewPreArrivalForm.styles';

const ArrivalInformationSection = () => {
  const { t } = useTranslation();
  const { shouldShowField } = useShouldShowField();

  return (
    <>
      <ArrivalInfoContainer data-testid="preview-arrival-information-section">
        <h2>
          {t('pageAutomations.preArrivalForm.preview.arrivalInfo.header')}
        </h2>

        <PreviewRow columns={4}>
          {shouldShowField(
            PreArrivalFormFields.ARRIVAL_FLIGHT_NUMBER,
            <TextField
              colSmInput={12}
              name="preview.arrivalFlightNumber"
              labelOnTop
              label={t(
                'pageAutomations.preArrivalForm.preview.arrivalInfo.flightNumber',
              )}
            />,
          )}

          {shouldShowField(
            PreArrivalFormFields.ARRIVAL_REASON_FOR_TRIP,
            <TextField
              colSmInput={12}
              name="preview.arrivalReasonForTrip"
              labelOnTop
              label={t(
                'pageAutomations.preArrivalForm.preview.arrivalInfo.reasonForTrip',
              )}
            />,
          )}
        </PreviewRow>

        <PreviewRow columns={4}>
          {shouldShowField(
            PreArrivalFormFields.ARRIVAL_ESTIMATED_ARRIVAL_TIME,
            <DateTimePickerField
              colSmInput={12}
              name="preview.arrivalEstimatedArrivalDate"
              labelOnTop
              label={t(
                'pageAutomations.preArrivalForm.preview.arrivalInfo.estimatedArrivalDate',
              )}
            />,
          )}

          {shouldShowField(
            PreArrivalFormFields.ARRIVAL_ESTIMATED_ARRIVAL_TIME,
            <DateTimePickerField
              timeOnly
              colSmInput={12}
              name="preview.arrivalEstimatedArrivalTime"
              labelOnTop
              label={t(
                'pageAutomations.preArrivalForm.preview.arrivalInfo.estimatedArrivalTime',
              )}
            />,
          )}
        </PreviewRow>

        <PreviewRow columns={4}>
          {shouldShowField(
            PreArrivalFormFields.ARRIVAL_ESTIMATED_DEPARTURE_TIME,
            <DateTimePickerField
              colSmInput={12}
              name="preview.arrivalEstimatedDepartureDate"
              labelOnTop
              label={t(
                'pageAutomations.preArrivalForm.preview.arrivalInfo.estimatedDepartureDate',
              )}
            />,
          )}

          {shouldShowField(
            PreArrivalFormFields.ARRIVAL_ESTIMATED_DEPARTURE_TIME,
            <DateTimePickerField
              timeOnly
              colSmInput={12}
              name="preview.arrivalEstimatedDepartureTime"
              labelOnTop
              label={t(
                'pageAutomations.preArrivalForm.preview.arrivalInfo.estimatedDepartureTime',
              )}
            />,
          )}
        </PreviewRow>
      </ArrivalInfoContainer>

      <PreviewDivider />
    </>
  );
};

export default ArrivalInformationSection;
